<sc-padding *ngIf="station?.stationUsage?.transports.length>0" fitHeight>
    <sc-scroll-pane>
        <app-transport-details [transport]="station?.stationUsage?.transports[0]" [mode]="TransportDetailMode.READONLY"
            [layout]="layoutDefinition"></app-transport-details>
    </sc-scroll-pane>
</sc-padding>
